angular.module('App.video.service', []).service('videoService', [
    function() {}
])
    .service("videoPageService",[function(){
        var videoPageService = {};

        videoPageService.setPageType = angular.noop;
        return videoPageService;
    }])

    .service('VideoInterviewInviteModalService', ['$q', '$timeout',
        function($q, $timeout) {
            var videoInviteService = {};
            //VA: once the video is disabled. It still shows in the workflow drop down. What should we do in that case?
            // It will throw exception if don't include the below code. Need to discuss with the video team.
            videoInviteService.invite = function() {
                var q = $q.defer();
                $timeout(function() {
                    q.resolve(false);
                }, 500);
                return q.promise;
            };
            return videoInviteService;
        }
    ]);
angular.module('App.video.details', []);
angular.module('App.video.evals', []);
angular.module('App.video.list', []);
angular.module('jv.CandDetails.Video', []);
angular.module('App.video.recruiter.router', []);
angular.module('jv.video.recruiter.list.controller', []);
angular.module('jv.video.recruiter.details.controller', []);
angular.module('jv.video.recruiter.evaluations.controller', []);

//VA: Nasty hack for now. Check if the date picker module is available add it if not available.
try{
    angular.module('jv.Common.Directives.Datepicker')
}
catch(e){
    angular.module('jv.Common.Directives.Datepicker',[])
}


